import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import React, { useContext } from "react";
import { getLabelTagsWithDescription } from "../constructTextFromValues";
import { treatmentGivenOptions } from "../../Options/RespiratoryTherapistOptions";
import treatmentIcon from "../../../../assets/doctorIcons/treatment.svg";

const RespiratoryTreatmentPlanSummary = ({ context }) => {
  const { formData } = useContext(context);
  const constructTreatmentSummaryItems = () => {
    const treatmentSummaryItems = [];
    treatmentSummaryItems.push({
      key: "1",
      label: "Treatment Plan",
      children: (
        <>
          {getLabelTagsWithDescription(
            treatmentGivenOptions,
            formData?.treatment_plan
          )}
        </>
      ),
    });
    return treatmentSummaryItems;
  };
  const treatmentSummaryItems = constructTreatmentSummaryItems();
  return (
    <SummaryWrapper
      items={treatmentSummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image src={treatmentIcon} width={18} preview={false} />
            <span style={{ fontSize: "16px", fontWeight: "normal" }}>
              Treatment
            </span>
          </Space>
        </span>
      }
    />
  );
};

export default RespiratoryTreatmentPlanSummary;
